module.exports = __webpack_public_path__ + "static/media/gold-star.ee2b0518.svg";